import { InputBase, makeStyles, withStyles } from "@material-ui/core";

export const BasicInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3),
      fontFamily: 'Poppins !important',
    },
    "&.MuiInputBase-multiline": {
      padding: "0 !important",
    },
    "& .MuiInputAdornment-positionEnd": {
      position: "absolute",
      right: "12px",
    },
  },

  input: {
    position: "relative",
    backgroundColor: "white !important",
    fontSize: "15px !important",
    margin: "0 !important",
    height: "2.5rem !important",
    padding: "10px 12px 10px  !important",
    borderRadius: "4px !important",
    border: "1px solid #ced4da !important",
    fontWeight: '500',
    transition: theme.transitions.create(["border-color", "box-shadow"]),

    "&:focus": {
      borderRadius: 4,
      boxShadow: "unset !important",
    },

    "&::placeholder": {
      color: "#082852 !important",
      fontWeight: "500 !important",
      fontSize: "15px " 
    },
  },
}))(InputBase);


export const BasicInputSelect = withStyles((theme) => ({
  root: {
      "label + &": {
          marginTop: theme.spacing(3),
      },
  },
  input: {
      backgroundColor: "white !important",
      position: "relative",
      fontSize: "15px !important",
      margin: "0 !important",
      padding: " 9px  !important",
      borderRadius: "4px !important",
      border: "1px solid #ced4da !important",
      height: '37.5px !important',
      boxSizing: 'border-box !important',
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      "&:focus": {
          borderRadius: 4,
          boxShadow: "unset !important",
          backgroundColor: "#fff !important"
      },
      "&::placeholder": {
          color: "#082852 !important",
      },

  },
}))(InputBase);

export const AddContactModalV2Styles = makeStyles({
  headlineWrapper: {
    color: "white",
    backgroundColor: "#3C7EF3",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    padding: "10px 16px",
    borderRadius: "5px",

    "& .MuiDivider-root": {
      color: "white",
      backgroundColor: "white",
    },
  },
  menuItem: {
      color: "#133159",
    "&:hover": {
      backgroundColor: "#cbd4ff",
      color: "#133159",
    },
    "&.Mui-selected": {
      backgroundColor: "#cbd4ff",
      color: "#133159",
    },
  },
  focusBackground: {
    "&.MuiIconButton-root:focus": {
      backgroundColor: "unset",
    },
  },
  labelMarginBottom: { marginBottom: 4 },

  addressHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  manualEntryButton: {
    backgroundColor: "#3C7EF3",
    fontWeight: "600px",
    color: "white",
    padding: "5px",
    borderRadius: "5px",
    marginBottom: "5px",
    "&:hover": {
      backgroundColor: "#3C7EF3",
      color: "white",
    },
    "&:focus": {
      backgroundColor: "#3C7EF3",
      color: "white",
    },
  },
});
export const useStyles = makeStyles((theme) => ({
  titleContainer: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
    justifyContent: "start",
  },
  menuItem: {
    "&:hover": {
      backgroundColor: "#cbd4ff",
      color: "#133159",
    },
    "&.Mui-selected": {
      backgroundColor: "#cbd4ff",
      color: "#133159",
    },
  },
  focusBackground: {
    "&.MuiIconButton-root:focus": {
      backgroundColor: "unset",
    },
  },
  labelMarginBottom: { marginBottom: 4 },

  headlineWrapper: {
    color: "#3C7EF3",
    backgroundColor: "#e8f0fe",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    padding: "10px 16px",
    borderRadius: "5px",
    marginBottom: "8px",
    border: "1px solid #3C7EF3",

    "& .MuiDivider-root": {
      color: "white",
      backgroundColor: "white",
    },
  },
  googlePlacesAutocomplete: {
    width: "100%",
    marginTop: theme.spacing(2),
    "& .my-google-places-autocomplete__value-container": {
      padding: "0px 8px",
    },
    "& .my-google-places-autocomplete__input": {
      height: "16px !important",
      textAlign: "left !important",
      margin: "0 !important",
      border: "none !important",
      outline: "none !important",
      boxShadow: "none !important",
    },
    "& .my-google-places-autocomplete__input:focus": {
      border: "none !important",
      outline: "none !important",
      boxShadow: "none !important",
    },
    "& .my-google-places-autocomplete__control": {
      fontSize: "15px !important",
    },
    "& .my-google-places-autocomplete__input input": {
      height: "unset !important",
    },
  },
  addressHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  manualEntryButton: {
    backgroundColor: "#3e50f7 !important",
    color: "white !important",
    marginBottom: "10px",
    fontWeight: "700px",
    "&:hover,&:focus": {
      backgroundColor: "#3e50f7 !important",
      color: "white !important",
      opacity:0.8,
    },
  },
  flexCenter: {
    display: "flex",
    alignItems: "center",
  },
  flexColumn: {
    display: "flex",
    flexDirection: "column",
  },
  formLabel: {
    fontWeight: "600 !important",
    color: "#181f48",
    marginBottom: "0px !important",
  },
  phoneNumberInput: {
    position: "relative",
    color: "var(--dark_blue)",
    backgroundColor: "white !important",
    fontSize: "15px !important",
    margin: "0 !important",
    height: "2.5rem !important",
    padding: "10px 12px 10px  !important",
    borderRadius: "4px !important",
    border: "1px solid #ced4da !important",
    transition: theme.transitions.create(["border-color", "box-shadow"]),

    "&:focus": {
      borderRadius: 4,
      boxShadow: "unset !important",
    },
  },
  addButtonStyle: {
    backgroundColor: "#00ff91",
    borderRadius: "4px",
    height: "37px",
    width: "37px",
    display: "grid",
    placeItems: "center",
    cursor: "pointer",
  },
  logoContainer: {
    width: "50px",
    height: "50px",
  },
  logo: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
}));
